import {createStore} from 'vuex'
import axios from "axios";

interface Item {
    id: number
    name: string
    category: string
}

export interface Result {
    quizName: string
    passed: boolean
}

export default createStore({
    state: {
        resources: [
            {id: 1, name: 'Brood', category: 'food'},
            {id: 2, name: 'Cement', category: 'materials'},
            {id: 3, name: 'Schriften', category: 'schools'},
            {id: 4, name: 'Melk', category: 'food'},
            {id: 5, name: 'Hout', category: 'materials'},
            {id: 6, name: 'Krijt', category: 'schools'},
            {id: 7, name: 'Boeken', category: 'schools'},
            {id: 8, name: 'Pennen', category: 'schools'},
            {id: 9, name: 'Metaal', category: 'materials'},
            {id: 10, name: 'Soep', category: 'food'},
            {id: 11, name: 'Chocola', category: 'food'},
            {id: 12, name: 'Ramen', category: 'materials'}
        ],
        materials: [] as Item[],
        food: [] as Item[],
        schools: [] as Item[],
    },
    getters: {},
    mutations: {
        setResources(state, items: Item[]) {
            state.resources = items
        },
        setMaterials(state, items: Item[]) {
            state.materials = items
        },
        setFood(state, items: Item[]) {
            state.food = items
        },
        setSchool(state, items: Item[]) {
            state.schools = items
        },
    },
    actions: {
        updateResources({commit}, items: Item[]) {
            commit('setResources', items)
        },
        updateMaterials({commit}, items: Item[]) {
            commit('setMaterials', items)
        },
        updateFood({commit}, items: Item[]) {
            commit('setFood', items)
        },
        updateSchool({commit}, items: Item[]) {
            commit('setSchool', items)
        },
        sendResult(_, result: Result) {
            axios.post(
                "http://135.181.47.101:1234/api/result",
                result)
                .then(res => {
                    console.log("sending")
                    console.log(res.data)
                })
                .catch(err => console.log(err))
        }
    },
    modules: {}
})
